import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';

// -----------------  AUTH -------------------------------
const Loader = lazy(() => import('./components/loader.jsx'));
const Footer = lazy(() => import('./components/footer.jsx'));
const Login = lazy(() => import('./pages/auth/login.jsx'));
const Protected = lazy(() => import('./components/protected.config.js'));
const PageNotFound = lazy(() => import('./components/pageNotFound.jsx'));
const ForgetPassword = lazy(() => import('./pages/auth/forgetPassword.jsx'));
const ResetPassword = lazy(() => import('./pages/auth/resetPassword.jsx'));
const ChangePassword = lazy(() => import('./pages/auth/changePassword.jsx'));
const Profile = lazy(() => import('./pages/auth/profile.jsx'));
const Setting = lazy(() => import('./pages/auth/setting.jsx'));

// ------------------------ DASHBOARD --------------------------------
const Dashboard = lazy(() => import('./pages/dashboard.jsx'));

// ------------------------ CUSTOMER --------------------------------
const Customer = lazy(() => import('./pages/customers/customer.jsx'));
const ViewCustomer = lazy(() => import('./pages/customers/view.jsx'));

// ------------------------ DRIVER --------------------------------
const Driver = lazy(() => import('./pages/driver/driver.jsx'));
const AddDriver = lazy(() => import('./pages/driver/add_driver.jsx'));
const ViewDriver = lazy(() => import('./pages/driver/view_driver.jsx'));
const EditDriver = lazy(() => import('./pages/driver/edit_driver.jsx'));
const DriverRides = lazy(() => import('./pages/driver/driverRides.jsx'));
const DriverMap = lazy(() => import('./pages/driver/driverMap.jsx'));

// ------------------------ VehicleTypes --------------------------------
const VehicleTypes = lazy(() => import('./pages/vehicleTypes/vehicleTypes.jsx'));
const AddVehicle = lazy(() => import('./pages/vehicleTypes/add_vehicle.jsx'));
const EditVehicle = lazy(() => import('./pages/vehicleTypes/edit_vehicle.jsx'));
const ViewVehicle = lazy(() => import('./pages/vehicleTypes/view_vehicle.jsx'));

// ------------------------ Driver Document --------------------------------

const DriverDocumentList = lazy(() => import('./pages/driverDocuments/driver_document_list.jsx'));


// ------------------------ Rides --------------------------------

const Rides = lazy(() => import('./pages/rides/rideList.jsx'));
const ViewRide = lazy(() => import('./pages/rides/view_ride.jsx'));

// ------------------------ Earning --------------------------------

const Earning = lazy(() => import('./pages/earning/earnings.jsx'));

// ------------------------ Settlments --------------------------------

const Settlement = lazy(() => import('./pages/settlement/settlementList.jsx'));


//  --------------------------  NOTIFICATION  ---------------------------------
const Notification = lazy(() => import('./pages/notification/notification.jsx'));
const AddNotification = lazy(() => import('./pages/notification/add.jsx'));
const ViewNotification = lazy(() => import('./pages/notification/view.jsx'));


// ------------------------ CMS --------------------------------
const AboutUs = lazy(() => import('./pages/appContent/aboutUs.jsx'));
const PrivacyPolicy = lazy(() => import('./pages/appContent/privacyPolicy.jsx'));
const TermsCondition = lazy(() => import('./pages/appContent/termsCondition.jsx'));
const Faq = lazy(() => import('./pages/appContent/faq.jsx'));
const ViewFaq = lazy(() => import('./pages/appContent/view-faq.jsx'));


// -------------------   REPORT   ----------------------------
const MileageReport = lazy(() => import('./pages/report/mileageReport.jsx'));


//  --------------------------  SAMPLE REQUEST ---------------------------------
const SampleRequest = lazy(() => import('./pages/sampleRequest/sampleRequest.jsx'));
const ViewSampleRequest = lazy(() => import('./pages/sampleRequest/view.jsx'));

// ------------------------- CONTACT-US ------------------------------
const ContactUs = lazy(() => import('./pages/contactUs/contactUs.jsx'));


const AuthenticatedRoutes = () => {
  return (
    <Suspense>
      <Protected>
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/setting" element={<Setting />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/user" element={<Customer />} />
          <Route path="/view-user/:id" element={<ViewCustomer />} />
          <Route path="/drivers" element={<Driver />} />
          <Route path="/add_driver" element={<AddDriver />} />
          <Route path="/edit_driver/:id" element={<EditDriver />} />
          <Route path="/view_driver/:id" element={<ViewDriver />} />
          <Route path="/driver_rides/:id" element={<DriverRides />} />
          <Route path="/driver_map" element={<DriverMap />} />


          <Route path="/vehicle_types" element={<VehicleTypes />} />
          <Route path="/add_vehicle" element={<AddVehicle />} />
          <Route path="/edit_vehicle/:id" element={<EditVehicle />} />
          <Route path="/view_vehicle/:id" element={<ViewVehicle />} />
          <Route path="/documnet_requests" element={<DriverDocumentList />} />
          <Route path="/about_us" element={<AboutUs />} />
          <Route path="/privacy_policy" element={<PrivacyPolicy />} />
          <Route path="/terms_conditions" element={<TermsCondition />} />
          {/* <Route path="/terms_condition" element={<TermsCondition />} /> */}
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/rides" element={<Rides />} />
          <Route path="/view_ride/:id" element={<ViewRide />} />
          <Route path="/earnings" element={<Earning />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/add-notification" element={<AddNotification />} />
          <Route path="/view-notification/:id" element={<ViewNotification />} />
          <Route path="/settlements" element={<Settlement />} />


          <Route path="/mileage_report" element={<MileageReport />} />



          <Route path="/sample-request" element={<SampleRequest />} />
          <Route path="/view-sample-request" element={<ViewSampleRequest />} />



          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Protected>
    </Suspense>
  );
};

function App() {
  return (
    <BrowserRouter basename="/">
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path='/view_faq/:user_type' element={<ViewFaq />} />
          <Route path='/*' element={<AuthenticatedRoutes />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
